var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#667085",
    d: "m9.857 1.164-.67.39a6.336 6.336 0 0 1-6.374 0l-.67-.39A4.26 4.26 0 0 0 0 .585v.703c.237 0 .472.024.703.07v3.543l3.362-1.905L6 6.348l1.935-3.352 3.362 1.905V1.359c.23-.047.466-.07.703-.07V.584c-.752 0-1.493.2-2.143.579Zm-8.45.415c.13.056.258.12.382.192l.67.39c.285.167.58.312.885.436L1.406 3.694V1.58Zm3.49 1.452a7.025 7.025 0 0 0 2.206 0L6 4.941l-1.103-1.91Zm5.697.663L8.656 2.597c.304-.124.6-.269.885-.435l.67-.39c.124-.073.252-.137.383-.193v2.115Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#667085",
    d: "M9.187 6.622a6.336 6.336 0 0 1-6.374 0l-.67-.39A4.26 4.26 0 0 0 0 5.651v.703c.237 0 .472.024.703.07v3.543l3.362-1.904L6 11.414l1.935-3.35 3.362 1.904V6.426c.23-.047.466-.07.703-.07v-.704c-.752 0-1.493.2-2.143.58l-.67.39Zm-7.78.024c.13.057.258.12.382.193l.67.39c.285.166.58.312.885.435L1.406 8.762V6.646Zm3.49 1.452a7.025 7.025 0 0 0 2.206 0L6 10.008l-1.103-1.91Zm5.697-1.452v2.116L8.656 7.664c.304-.124.6-.269.885-.435l.67-.39c.124-.072.252-.136.383-.193Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoreIcon);
export default __webpack_public_path__ + "static/media/decore-icon.3c51bcb47411a4059b4fd912ebe037ac.svg";
export { ForwardRef as ReactComponent };